// File: context/UserContext.jsx

import { createContext, useContext, useEffect, useState } from "react";
import { useSession } from "next-auth/react";

// Create a context with two fields: the current user, and the loading status
const UserContext = createContext({
  user: null,
  status: "loading",
});

export function UserProvider({ children }) {
  // Grab the NextAuth session and status
  const { data: session, status } = useSession();
  const [user, setUser] = useState(null);

  useEffect(() => {
    // When we’re authenticated, pull fields off session.user
    if (status === "authenticated" && session.user) {
      setUser({
        id:      session.user.id,      // your DB PK
        uid:     session.user.uid,     // firebase_uid
        email:   session.user.email,
        name:    session.user.name,
        image:   session.user.image,
        isAdmin: session.user.isAdmin, // <-- new admin flag
      });
    } else {
      // Not signed in or still loading
      setUser(null);
    }
  }, [session, status]);

  return (
    <UserContext.Provider value={{ user, status }}>
      {children}
    </UserContext.Provider>
  );
}

// Custom hook for easy access to { user, status }
export function useUser() {
  return useContext(UserContext);
}
